import Scene from '../../classes/scene';
import BrainTextTransition from '../brains/brainTextTransition';

export default class SceneTextDemo extends Scene {
		
	constructor(args) {
		super(args);
		this.pointer = true;
	}

	init(data) {
		super.init(data);

		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.system.display.settings.lfoMult = 0.3;

		f.text({
			x: scr.width/2,
			y: scr.height/2,
			scale: 4.5,
			text:`ABCDEFGHIJ\nKLMNOPQRST\nUVWXYZ1234\n567890!?*%\n().,'":;/+\n=-#[]~&|@<\n>{}$^_`,
			color: 0x00cc66,
			brain: new BrainTextTransition(),
			interactive: true,
		});

		f.button({
			x:'100% -50', y:50, scale: 1,
			text:'exit',
			align:'right',
			color: pal.red,
			onClick: () => {
				this.system.sceneManager.changeScene('sceneExample');
				this.system.audio.playSample('gui_tiny');
				this.system.audio.stopMusic();
			}
		});

		this.system.audio.playMusic('homes_for_waifs');
	}

}